<template>
	<footer class="footer">
		<template v-if="items && items.length > 0">
			<FooterNav
				v-for="(item, index) of items"
				:key="`footer__nav__${index}`"
				:fields="item.fields"
				class="footer__links"
			/>
		</template>

		<ul class="footer__links">
			<li class="link">{{ copyrightText }}</li>
		</ul>

		<PictureImg v-if="showIcon" class="footer__logo" :media="showIcon" />
	</footer>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const copyrightText = computed(() => props.fields?.copyrightText?.value);
const items = computed(() => props.fields?.items || []);
const showIcon = computed(() => props.fields?.showIcon?.value);
</script>

<style lang="scss">
.footer {
	position: relative;
	padding: var(--spacing-6, 48px) var(--spacing-2, 16px) var(--spacing-5, 40px)
		var(--spacing-2, 16px);
	background-color: transparent;

	.footer__title {
		text-transform: uppercase;
		font-family: var(--primary-font, sans-serif);
		font-weight: bold;
		font-size: var(--text-base, 16px);
		color: #eee;
	}

	.footer__links {
		list-style-type: none;
		margin-bottom: var(--spacing-4, 32px);
		padding-left: 0;

		li {
			margin-bottom: var(--spacing-025, 2px);
		}
	}

	.link {
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-sm, 14px);
		text-decoration: none;
		color: #eee;

		svg {
			margin-bottom: -2px;
		}
	}

	.footer__logo {
		position: absolute;
		right: var(--spacing-3, 24px);
		bottom: 128px;
		height: 90px;
		width: 105px;

		img {
			margin-bottom: 0;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}
</style>
